<template>
	<view class="hot">
		<!-- 菜品图 -->
		<view class="hot_img">
			<image src="@/static/images/Mask group@2x.png" mode="widthFix"></image>
		</view>
		<!-- 菜品信息 -->
		<view class="hot_info">
			<view class="hot_info_price">
				<text>¥</text>
				<text>26</text>
			</view>
			<view class="hot_info_title">
				澳白Flatwhite
			</view>
			<view class="hot_info_text">
				甄选来自秘鲁中部产区极负盛名的禅茶玛悠咖啡，经过深度烘焙，香气馥郁，口感更浓郁顺滑。
			</view>
		</view>
		<!-- 精彩评论 -->
		<view class="store_remak">
			<view class="list">
				<view class="list_item">
					<view class="list_item_head">
						<view class="list_item_head_left">
							<image src="@/static/logo.png" mode="widthFix"></image>
							<text>木**王</text>
						</view>
						<text class="list_item_head_time">2022-12-29</text>
					</view>
					<view class="list_pf">
						<uni-rate :value="5" size="18" color="#bbb" active-color="red" />
					</view>
					<view class="list_wz">
						能用这个价位买到这样的质量真心值啦，做工精致用料
						实在讲究，商家用心喽，不说价位质量与几百相比没什
						么区别，值得购入！
					</view>
					<view class="list_imgs">
						<image src="@/static/images/Mask group@2x.png" mode="widthFix"></image>
						<image src="@/static/images/Mask group@2x.png" mode="widthFix"></image>
						<image src="@/static/images/Mask group@2x.png" mode="widthFix"></image>
					</view>
					<view class="list_help">
						<image src="@/static/icon/ic_dianzan@2x.png" mode="widthFix"></image>
						<text>2</text>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hot {
		width: 100%;
		.hot_img {
			width: 100%;
			height: 564rpx;
			image {
				width: 100%;
				height: 100%;
			}
		}
		.hot_info {
			display: flex;
			flex-direction: column;
			padding: 28rpx 32rpx;
			background-color: #ffffff;
			.hot_info_price {
				display: flex;
				align-items: flex-end;
				text {
					&:first-child {
						font-size: 28rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #D20A0A;
					}
					&:last-child {
						font-size: 40rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #D20A0A;
					}
				}
			}
			.hot_info_title {
				font-size: 36rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-top: 16rpx;
			}
			.hot_info_text {
				font-size: 28rpx;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				margin-top: 16rpx;
			}
		}
		.store_remak {
			width: 100%;
			margin-top: 16rpx;
			padding: 28rpx 30rpx;
			box-sizing: border-box;
			background-color: #FFFFFF;
			.list {
				width: 100%;
				display: flex;
				flex-direction: column;
				.list_item {
					display: flex;
					flex-direction: column;
					padding-bottom: 28rpx;
					border-bottom: 2rpx solid #F4F5F4;
					.list_pf {
						width: 100%;
						margin: 22rpx 0 24rpx 0;
					}
					.list_wz {
						font-size: 28rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #000000;
					}
					.list_imgs {
						width: 100%;
						margin-top: 24rpx;
						display: flex;
						align-items: center;
						image {
							width: 220rpx;
							height: 220rpx;
							margin-right: 12rpx;
							&:last-child {
								margin-right: 0 !important;
							}
						}
					}
					.list_help {
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						margin-top: 22rpx;
						image {
							width: 30rpx;
							height: 30rpx;
							margin-right: 6rpx;
						}
						text {
							font-size: 24rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
					.list_item_head {
						display: flex;
						align-items: center;
						justify-content: space-between;
						.list_item_head_left {
							display: flex;
							align-items: center;
							image {
								width: 64rpx;
								height: 64rpx;
								border-radius: 50%;
								margin-right: 12rpx;
							}
							text {
								font-size: 28rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #333333;
							}
						}
						.list_item_head_time {
							font-size: 24rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
						}
					}
				}
			}
		}
	}
</style>